import { render } from "./SignupForm.vue?vue&type=template&id=6f3cbc1f&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=6f3cbc1f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f3cbc1f"

export default script